// Title-case a string for display: "gana lakshmi" → "Gana Lakshmi",
// "ACTIVE" → "Active". Splits on whitespace, capitalises each word's first
// letter and lower-cases the rest. Hyphenated parts are handled too.
export function titleCase(input: string | null | undefined): string {
  if (!input) return '';
  return String(input)
    .toLowerCase()
    .split(/(\s+)/) // keep the whitespace separators
    .map((word) =>
      word
        .split('-')
        .map((part) => (part ? part.charAt(0).toUpperCase() + part.slice(1) : part))
        .join('-'),
    )
    .join('');
}
